import { facility } from 'config/constants';
import {ReactComponent as elevatorsImg} from "assets/images/facilities/elevators.svg" 
import {ReactComponent as escalatorsImg} from "assets/images/facilities/escalators.svg" 
import {ReactComponent as toiletsImg} from "assets/images/facilities/toilets.svg" 
import {ReactComponent as atmsImg} from "assets/images/facilities/atms.svg" 
import {ReactComponent as restAreaImg} from "assets/images/facilities/restArea.svg" 
import {ReactComponent as lockersImg} from "assets/images/facilities/lockers.svg" 
import {ReactComponent as babyCareImg} from "assets/images/facilities/babyCare.svg" 
import {ReactComponent as chargeAreaImg} from "assets/images/facilities/chargeArea.svg" 
import {ReactComponent as smokeAreaImg} from "assets/images/facilities/smokeArea.svg" 
import {ReactComponent as infoStallImg} from "assets/images/facilities/infoStall.svg" 
import { ReactComponent as iconTaxi} from 'assets/images/facilities/Taxi.svg';

const facilityName = {
  [facility.elevators]: {
    en: 'Elevator',
    vi: 'Thang máy',
  },
  [facility.escalators]: {
    en: 'Escalator',
    vi: 'Thang cuốn',
  },
  [facility.toilets]: {
    en: 'Toilet',
    vi: 'Nhà vệ sinh',
  },
  [facility.atms]: {
    en: 'ATM',
    vi: 'Máy rút tiền',
  },
  [facility.restArea]: {
    en: 'Rest area',
    vi: 'Khu vực nghỉ',
  },
  [facility.chargeArea]: {
    en: 'Phone charging station',
    vi: 'Sạc pin điện thoại',
  },
  [facility.lockers]: {
    en: 'E-locker',
    vi: 'Tủ gửi đồ',
  },
  [facility.babyCare]: {
    en: 'Baby room',
    vi: 'Phòng mẹ và bé',
  },
  [facility.smokeArea]: {
    en: 'Smoking Space',
    vi: 'Khu hút thuốc',
  },
  [facility.infoStall]: {
    en: 'Information counter',
    vi: 'Quầy thông tin',
  },
  [facility.taxi]: {
    en: 'Taxi station',
    vi: 'Điểm dừng Taxi',
  },
}

const facilityIcon = {
  [facility.elevators]: elevatorsImg,
  [facility.escalators]:  escalatorsImg, 
  [facility.toilets]:  toiletsImg, 
  [facility.atms]:  atmsImg, 
  [facility.restArea]: restAreaImg, 
  [facility.chargeArea]: chargeAreaImg,
  [facility.lockers]:  lockersImg, 
  [facility.babyCare]:  babyCareImg, 
  [facility.smokeArea]:  smokeAreaImg, 
  [facility.infoStall]:  infoStallImg, 
  [facility.taxi]: iconTaxi
}

const facilityTags = {
  [facility.elevators]: "thang may",
  [facility.escalators]:  "thang cuon", 
  [facility.toilets]:  "wc,ve sinh,nha ve sinh", 
  [facility.atms]:  "atm,máy rút tiền", 
  [facility.restArea]: "phong nghi", 
  [facility.chargeArea]: "sạc pin điện thoại",
  [facility.lockers]:  "tu do", 
  [facility.babyCare]:  "Phòng mẹ và bé'", 
  [facility.smokeArea]:  "Khu hút thuốc", 
  [facility.infoStall]:  "Quầy thông tin", 
  [facility.taxi]: "Điểm dừng Taxi"
}


export {facility, facilityName, facilityIcon, facilityTags}